import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import logo from "../assets/icon/logo.png";
import arquivo from "../assets/politica_de_privacidade.pdf";
import arquivo2 from "../assets/relatorio_de_igualdade_salarial_2026_01.pdf";
import arquivo3 from "../assets/relatorio_de_igualdade_salarial_2026_02.pdf";
import arquivo4 from "../assets/relatorio_de_sustentabilidade_ambiental_e_social_2025.pdf";

function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`footer-bg ${isVisible ? "visible" : ""}`}>
        <div className="footer">
          <div className="logo">
            <img
              className={`${isVisible ? "visible" : ""}`}
              src={logo}
              alt="Logotipo da empresa"
              width={"250px"}
            />
            <div className={`line ${isVisible ? "visible" : ""}`}></div>
          </div>
          <div className={`address ${isVisible ? "visible" : ""}`}>
            <p className={`address ${isVisible ? "visible" : ""}`}>GH OPERADOR LOGISTICO LTDA - 07.656.322/0001-32</p>
          </div>
          <div className={`rights ${isVisible ? "visible" : ""}`}>
            <p>{t("footer_rights")}</p>
          </div>
          <div className={`singlec ${isVisible ? "visible" : ""}`}>
            <p>
              {t("footer_privacy")}{" "}
              <a
                href={arquivo}
                target="_blank"
                rel="noreferrer"
                download="política_de_privacidade.pdf"
              >
                {t("footer_privacy_link")}
              </a>
            </p>
          </div>
          <div className={`singlec ${isVisible ? "visible" : ""}`}>
            <p>
              <a
                href={arquivo2}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_igualdade_salarial_2026_semestre_01.pdf"
              >
                {t("footer_equality1_link")}
              </a>
            </p>
            <p>
              <a
                href={arquivo3}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_igualdade_salarial_2026_semestre_02.pdf"
              >
                {t("footer_equality2_link")}
              </a>
            </p>
            <p>
              <a
                href={arquivo4}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_sustentabilidade_ambiental_e_social_2025.pdf"
              >
                {t("footer_sustainability_link")}
              </a>
            </p>
          </div>
          <div className={`singlec ${isVisible ? "visible" : ""}`}>
            <p>
              {t("footer_developed")}{" "}
              <a
                href="https://singlec.com.br/"
                target="_blank"
                rel="noreferrer"
              >
                Singlec
              </a>
            </p>
          </div>
        </div>
        <div className="footer2">
          <ul>
            <h2>{t("footer_company")}</h2>
            <div className="underline"></div>
            <li>
              <a href={"/about"}>{t("footer_about")}</a>
            </li>
            <li>
              <a href={"/services"}>{t("footer_solutions")}</a>
            </li>
            <li>
              <a href={"/warehouseStructure"}>{t("footer_warehouse")}</a>
            </li>
            <li>
              <a href={"/fleetStructure"}>{t("footer_fleet")}</a>
            </li>
          </ul>
          <ul>
            <h2>{t("footer_content")}</h2>
            <div className="underline"></div>
            <li>
              <a href={"/blog"}>{t("footer_blog")}</a>
            </li>
            <li>
              <a href={"/esg"}>{t("footer_esg")}</a>
            </li>
          </ul>
          <ul>
            <h2>{t("footer_contact")}</h2>
            <div className="underline"></div>
            <li>
              <a href={"/contact"}>{t("footer_budget")}</a>
            </li>
            <li>
              <a href={"/anonymousReports"}>{t("footer_reports")}</a>
            </li>
            <li>
              <a href={"/career"}>{t("footer_career")}</a>
            </li>
          </ul>
          <ul className="listThree">
            <h2>{t("footer_branches")}</h2>
            <div className="underline"></div>
            <li>Itajaí - SC</li>
            <li>Garuva - SC</li>
            <li>Juiz de Fora - MG</li>
            <li>Carazinho - RS</li>
            <li>Campina Grande do Sul - PR</li>
            <li>Recife - PE</li>
            <li>Luis Eduardo Magalhães - BA</li>
            <li>Cuiabá - MT</li>
            <li>Paranaíba - MS</li>
            <li>Jacareí - SP</li>
            <li>Resende - RJ</li>
            <li>CSL Itajaí - SC</li>
          </ul>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default Footer;
